/* eslint-disable */
import createIcon from '../createIcon';

const IconSearchOutlined = createIcon({
  name: 'icon-search-outlined',
  content: '<path d="M449.235 799.064A350.467 350.467 0 11799.7 446.05a350.467 350.467 0 01-350.466 353.015zm0-637.212A286.745 286.745 0 10735.98 446.049a286.108 286.108 0 00-286.745-284.197z"/><path d="M670.347 714.06l45.051-45.05 135.217 135.152-45.051 45.05z"/>',
  width: 1024,
  height: 1024
});
export default IconSearchOutlined;
